module.exports = __webpack_public_path__ + "img/logoText.afa0cd55.svg";